import { useLocalStorage } from 'usehooks-ts'

export type Configuration = {
    personalizedInformation: string;
    personalizedResponseBehavior: string;
}

export const useConfiguration = (): {config: Configuration, update: (config: Configuration)=>void} => {
    const [personalizedInformation, setPersonalInformation] = useLocalStorage('personal_information', '');
    const [personalizedResponseBehavior, setPersonalResponseBehavior] = useLocalStorage('personalized_response_behavior', '');
    return {
        config: {
            personalizedInformation, personalizedResponseBehavior
        },
        update: (config: Configuration) => {
            setPersonalInformation(config.personalizedInformation);
            setPersonalResponseBehavior(config.personalizedResponseBehavior)
        }
    }
}